export const TERMS_OF_USE = 'https://libertasfunding.com/terms-conditions/';
export const PRIVACY_POLICY = 'https://libertasfunding.com/privacy-policy-2/';
export const CA_PRIVACY_NOTICE = 'https://libertasfunding.com/california-privacy-notice/';
